import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import siteConfig from '../data/siteConfig.json';
import SafeIcon from '../common/SafeIcon';
import { FiExternalLink, FiStar } from 'react-icons/fi';

const Reviews = () => {
  const { t } = useLanguage();

  const reviews = siteConfig.reviews;

  return (
    <div className="bg-white min-h-screen py-20 pb-32">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">{t('reviewsPage.title')}</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">{t('reviewsPage.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-slate-50 border border-slate-100 p-8 rounded-2xl shadow-sm"
            >
              <div className="flex text-yellow-400 mb-4">
                {[...Array(review.rating)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current text-lg" />)}
              </div>
              <p className="text-slate-700 italic mb-6 leading-relaxed">"{review.text}"</p>
              <div>
                <p className="font-bold text-slate-900">{review.name}</p>
                <p className="text-sm text-slate-500">{review.location}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={siteConfig.links.googleReviews}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-glass-blue hover:bg-blue-600 text-white px-8 py-4 rounded-lg font-bold transition-colors shadow-lg"
          >
            {t('common.viewGoogleReviews')}
            <SafeIcon icon={FiExternalLink} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
